import Index from './independent.zh';

export default Index;
